<template>
  <section class="section section-problems" ref="problemsSection">
    <div class="container">
      <h2 class="section-title">传统医药广阔市场，普遍面临六大难题</h2>
      <div class="problems-content">
        <div class="problem-circle-wrapper">
          <div class="problem-center-point">
            <CircleCom />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CircleCom from './CircleCom.vue'
export default {
  name: 'ProblemsSection',
  components: {
    CircleCom,
  },
}
</script>

<style scoped>
.section-problems {
  background: linear-gradient(180deg, #1ca19630 0%, #ffffff 100%);
  height: 923px;
}

.problems-content {
  position: relative;
  height: 739px;
  overflow: hidden;
}

.problem-circle-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.problem-center-point {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
}
.container {
  padding-top: 131px;
}
.section-title {
  text-align: center;
  font-size: 32px;
  color: #333;
  margin: 0;
  font-weight: 500;
}
</style>
